import React from "react";

// Словник для назв кнопок-фільтрів
const subjectTypeMap = {
  recommendation_price: "Ціни",
  recommendation_comment: "Коментарі",
  wholesale_markup: "Оптові націнки",
};

// Словник для назв дій
const actionTypeMap = {
  recommendation_price_updated: "Оновив(ла) ціну",
  recommendation_price_created: "Встановив(ла) ціну",
  recommendation_price_deleted: "Видалив(ла) ціну",
  recommendation_comment_created: "Додав(ла) коментар",
  recommendation_comment_updated: "Оновив(ла) коментар",
  wholesale_markup_updated: "Змінив(ла) оптові націнки",
};

// Словник для назв полів у 'properties'
const propertyKeyMap = {
  new_price: "Ціна",
  price_11: "Ціна 11",
  price_05: "Ціна 05",
  price_birthday: "Ціна ДН",
  new_price_cashless: "Ціна (Безготівка)",
  price_11_cashless: "Ціна 11 (Безготівка)",
  price_05_cashless: "Ціна 05 (Безготівка)",
  price_birthday_cashless: "Ціна ДН (Безготівка)",
  quantity_custom: "Кастомний залишок",
  markup_1: "Націнка від 1 шт, %",
  markup_5: "Націнка від 5 шт, %",
  markup_10: "Націнка від 10 шт, %",
  comment: "Коментар",
};

/**
 * Спеціальна функція-рендер для відображення 'properties'.
 */
const renderPropertyChanges = (properties) => {
  const { new_values, old_values, deleted_values } = properties;

  // Оновлення
  if (new_values && old_values) {
    return (
      <ul className="history-item__changes">
        {Object.keys(new_values).map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="old-value">{old_values[key] || "пусто"}</span>
            <span> → </span>
            <span className="new-value">{new_values[key] || "пусто"}</span>
          </li>
        ))}
      </ul>
    );
  }

  // Створення
  if (new_values) {
    return (
      <ul className="history-item__changes">
        {Object.keys(new_values).map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="new-value">{new_values[key] || "пусто"}</span>
          </li>
        ))}
      </ul>
    );
  }

  // Видалення
  if (deleted_values) {
    const meaningfulKeys = Object.keys(deleted_values).filter(
      (key) =>
        key !== "article" && key !== "warehouse_id" && deleted_values[key] !== null
    );
    if (meaningfulKeys.length === 0) return null;

    return (
      <ul className="history-item__changes deleted">
        {meaningfulKeys.map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="deleted-value">{deleted_values[key] || "пусто"}</span>
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

export const recommendationHistoryConfig = {
  subjectTypeMap,
  actionTypeMap,
  renderPropertyChanges,
};
